// extracted by mini-css-extract-plugin
export var divider = "_qk-0";
export var systemMessage = "_qk-1";
export var systemMessageWrapper = "_qk-2";